export const PARTY_SIZE_LIMIT = 7;
